import { render, staticRenderFns } from "./articList.vue?vue&type=template&id=d9527c68&scoped=true"
import script from "./articList.vue?vue&type=script&lang=js"
export * from "./articList.vue?vue&type=script&lang=js"
import style0 from "./articList.vue?vue&type=style&index=0&id=d9527c68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9527c68",
  null
  
)

export default component.exports